import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FileDto, ResultDto } from '@ideapa/common-dto';

export interface DuplicateModalFormValue {
  fromEsercizio: number;
  toEsercizio: number;
}

@Component({
  standalone: false,
  selector: 'ideapa-duplicate-modal',
  templateUrl: './duplicate-modal.component.html',
  styleUrls: ['./duplicate-modal.component.scss'],
})
export class DuplicateModalComponent implements OnInit {
  @Input()
  annoCorrente?: number;

  @Input()
  title!: string;

  @Output()
  duplicate = new EventEmitter<DuplicateModalFormValue>();

  @Input()
  result: ResultDto | undefined = undefined;

  @Output()
  downloadLog = new EventEmitter<FileDto>();

  @Output()
  closeModal = new EventEmitter<void>();

  form!: FormGroup;

  ngOnInit(): void {
    this.form = new FormGroup({
      fromEsercizio: new FormControl(this.annoCorrente, [Validators.required]),
      toEsercizio: new FormControl(Number(this.annoCorrente) + 1, [
        Validators.required,
        Validators.min(2017),
      ]),
    });
  }

  onDownloadLog() {
    this.downloadLog.emit(this.result?.logFile);
  }

  hasFile() {
    return this.result?.logFile != undefined;
  }

  onSubmit(form: FormGroup) {
    if (form.valid) {
      this.result = undefined;
      this.duplicate.emit(form.value);
    }
  }

  cancel() {
    this.closeModal.emit();
  }
}
